export default __webpack_public_path__ + "static/media/placed-check.1b1561c7.svg";